<!-- 充值 -->
<template>
<div class='main-content'>
  <Head :goBack='true' show="" title="关注送好礼"></Head>
  <div class="line">&nbsp;</div>
  <div class="contnet-box">
    <div class="title">
      关注送好礼
    </div>
    <div class="content">
      关注微信公众号，送{{couponsData.name||'送好礼'}}
      <!-- <span>20</span> -->
     
    </div>
    <div class="price">
      {{couponsData.name||''}}&nbsp;
      <!-- 20
      <span >
        元优惠券
      </span> -->
    </div>
    <div class="text1">付款即可直接抵扣</div>
    <div class="wx-img">
      <img :src="qrcode"  @touchstart="touchStart" @touchend="touchEnd"  alt=""/>
    </div>
    <div class="text2">长按图片，关注公众号</div>
    <div class="text3">优惠券可在“个人中心”-“我的优惠券”中查看</div>
    <div class="btn" @click="goBack">
      暂不关注，直接购买
    </div>
  </div>
</div>
</template>

<script>

export default {
//import引入的组件需要注入到对象中才能使用
components: {
},
data() {
//这里存放数据
  return {
    qrcode:'',
    touchStartTime: 0, // 记录触摸开始的时间
    longPressThreshold: 500 ,// 长按的阈值，单位是毫秒
    formData: {
      
    },
    couponsData:{

    }
  };
},
//监听属性 类似于data概念
computed:{
},
//监控data中的数据变化
watch: {},
//方法集合
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    getQrcode(){
      const params={
        deviceNum: this.deviceNum,
      }
      this.$api.coupon.getQrcode(params).then(res => {
        if (res.code == 200) {
          this.qrcode = res.qrcode
          this.$store.dispatch('submitTicket',res.ticket)
          this.couponsData = res.coupons&&res.coupons.length>0?res.coupons[0]:''
        }
      })
    },
    touchStart(e) {
      this.touchStartTime = e.timeStamp; // 记录触摸开始的时间戳
    },
    touchEnd(e) {
      let endTime = e.timeStamp;
      if (endTime - this.touchStartTime > this.longPressThreshold) { // 如果触摸时间超过阈值
        // 执行保存图片的操作
        let imageSrc = e.currentTarget.src; // 获取图片的src
        uni.saveImageToPhotosAlbum({ // 保存图片到相册
          filePath: imageSrc,
          success: function () {
            uni.showToast({
              title: '保存成功'
            });
          },
          fail: function (err) {
            console.log('保存失败：', err);
          }
        });
      }
    },
  // 获取套餐选项
  getDataList(){
    let data = {
      pageStart: this.pageNo,
      pageSize: this.pageSize,
      type:this.activeKey
    }
    if (this.pageNo == 1) {
      this.dataList = []
    }
    this.$api.coupon.getCouponList(data).then((res)=>{
      if(res.code==200){
        this.dataList = this.dataList.concat(res.result);
        if (res.result.length < this.pageSize) {
          this.finished = true;
        }
      }else{
        Toast(res.msg)
      }
    })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  this.getQrcode()
  // this.getFocusCoupons()
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  // this.getDataList()
},

beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.line{
  width: 100%;
  // height: 100px;
}
.main-content{
  background-color: #f7f7f7;
  .contnet-box{
    background: url('~@/assets/images/beijing.png') no-repeat center center;
    background-size:100% 100% ;
    width: 100%;
    height: 100vh;
    // height: calc(100vh - 100px);
    text-align: center;

    .title{
      padding-top: 18vh;
      font-size: 90px;
      // font-weight: 700;
      height: 9vh;
      color: #fff;
      text-shadow: 4px 4px 5px rgba(0,0,0,.5);
    }
    .content{
      color: #fff;
      font-size: 24px;
      line-height: 10vh;
      span{
        color: #fec43f;
      }
    }
    .price{
      padding-top: 2vh;
      line-height: 6vh;
      height: 6vh;
      font-size: 42px;
      font-weight: 800;
      color: #ee3c4a;
      span{
        font-weight: 400;
        font-size: 32px;
      }
    }
    .text1{
      color: #ee3c4a;
      font-size:22px;
      height: 3vh;
      line-height: 3vh;
    }
    .wx-img{
      height: 18vh;
      margin-top: 3vh;
      display: flex;justify-content: center;
      img{
        height: 100%;
      }
    }
    .text2{
      color: #fff;
      font-size:22px;
      font-weight: 600px;
      padding-top: 6vh;
      height: 3vh;
      line-height: 3vh;

    }
    .text3{
      font-size:22px;
      height: 3vh;
      padding-top: 5vh;
      color: #624827;
      padding-bottom: 1vh;
    }
    .btn{
     color: #fff;
     border: 1px solid #fff;
     font-size: 26px;
     height: 60px;
     line-height: 60px;
     width: 300px;
     border-radius: 60px;
     margin: 0 auto;
    }
  }
}
</style>